import { buildModelManager } from "../builder.js";
const DefaultBackInStockAlertSelection = {
  __typename: true,
  id: true,
  campaignId: true,
  contactId: true,
  createdAt: true,
  customerId: true,
  shopifyProductVariantId: true,
  status: true,
  updatedAt: true
};
const modelApiIdentifier = "backInStockAlert";
const pluralModelApiIdentifier = "backInStockAlerts";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultBackInStockAlertSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultBackInStockAlertSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultBackInStockAlertSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultBackInStockAlertSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultBackInStockAlertSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultBackInStockAlertSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultBackInStockAlertSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createBackInStockAlert",
    operationReturnType: "CreateBackInStockAlert",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      backInStockAlert: { required: false, type: "CreateBackInStockAlertInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultBackInStockAlertSelection
  },
  {
    type: "action",
    operationName: "bulkCreateBackInStockAlerts",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateBackInStockAlertsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultBackInStockAlertSelection
  },
  {
    type: "action",
    operationName: "updateBackInStockAlert",
    operationReturnType: "UpdateBackInStockAlert",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      backInStockAlert: { required: false, type: "UpdateBackInStockAlertInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultBackInStockAlertSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateBackInStockAlerts",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateBackInStockAlertsInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultBackInStockAlertSelection
  },
  {
    type: "action",
    operationName: "deleteBackInStockAlert",
    operationReturnType: "DeleteBackInStockAlert",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteBackInStockAlerts",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertBackInStockAlert",
    operationReturnType: "UpsertBackInStockAlert",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      backInStockAlert: { required: false, type: "UpsertBackInStockAlertInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateBackInStockAlertResult": { hasReturnType: false },
      "... on UpdateBackInStockAlertResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultBackInStockAlertSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertBackInStockAlerts",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertBackInStockAlertsInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultBackInStockAlertSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "backInStockAlertGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const BackInStockAlertManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultBackInStockAlertSelection,
  operations
);
export {
  BackInStockAlertManager,
  DefaultBackInStockAlertSelection
};
//# sourceMappingURL=BackInStockAlert.js.map
